export const newsLabels = {
    allNewsButton: {
        ru: 'Ко всем новостям',
        en: 'To all news',
        kz: 'Барлық жаңалықтар'
    },
    newsTitle: {
        ru: 'Новости',
        en: 'News',
        kz: 'Жаңалықтар'
    }
};

export const adsLabels = {
    allAdsButton: {
        ru: 'Ко всем объявлениям',
        en: 'To all ads',
        kz: 'Барлық хабарландырулар'
    },
    adsTitle: {
        ru: 'Объявления',
        en: 'Ads',
        kz: 'Хабарландырулар'
    }
};

export const newsPageLabels = {
    title: {
        ru: 'Новости',
        en: 'News',
        kz: 'Жаңалықтар'
    },
    pageTitle: {
        ru: 'Новости - AlmaU Open Library',
        en: 'News - AlmaU Open Library',
        kz: 'Жаңалықтар - AlmaU Open Кітапханасы'
    },
    metaDescription: {
        ru: 'Новости библиотеки AlmaU Open Library',
        en: 'News of the AlmaU Open Library',
        kz: 'AlmaU Open кітапханасының жаңалықтары'
    }
};

export const adsPageLabels = {
    title: {
        ru: 'Объявления',
        en: 'Announcements',
        kz: 'Хабарландырулар'
    },
    pageTitle: {
        ru: 'Объявления - AlmaU Open Library',
        en: 'Announcements - AlmaU Open Library',
        kz: 'Хабарландырулар - AlmaU Open Кітапханасы'
    },
    metaDescription: {
        ru: 'Объявления библиотеки AlmaU Open Library',
        en: 'Announcements of the AlmaU Open Library',
        kz: 'AlmaU Open кітапханасының хабарландырулары'
    }
};

export const coursesPageLabels = {
    title: {
        ru: 'Курсы',
        en: 'Courses',
        kz: 'Курстар'
    },
    pageTitle: {
        ru: 'Курсы - AlmaU Open Library',
        en: 'Courses - AlmaU Open Library',
        kz: 'Курстар - AlmaU Open Кітапханасы'
    },
    metaDescription: {
        ru: 'Курсы библиотеки AlmaU Open Library',
        en: 'Courses of the AlmaU Open Library',
        kz: 'AlmaU Open кітапханасының курстары'
    },
    allCategory: {
        en: 'All',
        ru: 'Все',
        kz: 'Барлық'
    },
};

export const eventsPageLabels = {
    title: {
        ru: 'Ивенты',
        en: 'Events',
        kz: 'Іс-шаралар'
    },
    pageTitle: {
        ru: 'Ивенты - AlmaU Open Library',
        en: 'Events - AlmaU Open Library',
        kz: 'Іс-шаралар - AlmaU Open Кітапханасы'
    },
    metaDescription: {
        ru: 'Ивенты библиотеки AlmaU Open Library',
        en: 'Events of the AlmaU Open Library',
        kz: 'AlmaU Open кітапханасының іс-шаралары'
    }
};

export const cinemaClubPageLabels = {
    title: {
        ru: 'Киноклуб',
        en: 'Cinema Club',
        kz: 'Киноклуб'
    },
    pageTitle: {
        ru: 'Киноклуб - AlmaU Open Library',
        en: 'Cinema Club - AlmaU Open Library',
        kz: 'Киноклуб - AlmaU Open Кітапханасы'
    },
    metaDescription: {
        ru: 'Киноклуб в библиотеке AlmaU Open Library',
        en: 'Cinema club at the AlmaU Open Library',
        kz: 'AlmaU Open кітапханасындағы киноклуб'
    }
};
export const bookClubPageLabels = {
    title: {
        ru: 'Книжный клуб',
        en: 'Book Club',
        kz: 'Кітап клубы'
    },
    pageTitle: {
        ru: 'Книжный клуб - AlmaU Open Library',
        en: 'Book Club - AlmaU Open Library',
        kz: 'Кітап клубы - AlmaU Open Кітапханасы'
    },
    metaDescription: {
        ru: 'Книжный клуб в библиотеке AlmaU Open Library',
        en: 'Book club at the AlmaU Open Library',
        kz: 'AlmaU Open кітапханасындағы кітап клубы'
    }
};
export const chessClubPageLabels = {
    title: {
        ru: 'Шахматный клуб',
        en: 'Chess Club',
        kz: 'Шахмат клубы'
    },
    pageTitle: {
        ru: 'Шахматный клуб - AlmaU Open Library',
        en: 'Chess Club - AlmaU Open Library',
        kz: 'Шахмат клубы - AlmaU Open Кітапханасы'
    },
    metaDescription: {
        ru: 'Шахматный клуб в библиотеке AlmaU Open Library',
        en: 'Chess club at the AlmaU Open Library',
        kz: 'AlmaU Open кітапханасындағы шахмат клубы'
    }
};
export const poetryClubPageLabels = {
    title: {
        ru: 'Поэтический клуб',
        en: 'Poetry Club',
        kz: 'Поэзия клубы'
    },
    pageTitle: {
        ru: 'Поэтический клуб - AlmaU Open Library',
        en: 'Poetry Club - AlmaU Open Library',
        kz: 'Поэзия клубы - AlmaU Open Кітапханасы'
    },
    metaDescription: {
        ru: 'Поэтический клуб в библиотеке AlmaU Open Library',
        en: 'Poetry club at the AlmaU Open Library',
        kz: 'AlmaU Open кітапханасындағы поэзия клубы'
    },
    meetingsTitle: {
        ru: 'Заседания клуба',
        en: 'Club meetings',
        kz: 'Клуб отырыстары'
    },
    noMeetings: {
        ru: 'Заседания клуба скоро появятся здесь',
        en: 'Club meetings will appear here soon',
        kz: 'Клуб отырыстары жақында осында пайда болады'
    },
    loadError: {
        ru: 'Не удалось загрузить заседания клуба',
        en: 'Failed to load club meetings',
        kz: 'Клуб отырыстарын жүктеу мүмкін болмады'
    }
};
export const singleNewsLabels = {
    latestNews: {
        en: 'Latest News',
        ru: 'Последние новости',
        kz: 'Соңғы жаңалықтар'
    },
    allNewsButton: {
        en: 'To all news',
        ru: 'Ко всем новостям',
        kz: 'Барлық жаңалықтарға'
    }
};
export const singleAdsLabels = {
    latestAds: {
        en: 'Latest Ads',
        ru: 'Последние объявления',
        kz: 'Соңғы хабарландырулар'
    },
    allAdsButton: {
        en: 'To all ads',
        ru: 'Ко всем объявлениям',
        kz: 'Барлық хабарландыруларға'
    }
};

export const cinemaSinglePageLabels = {
    latestCinema: {
        ru: 'Последние кино',
        en: 'Latest Cinema',
        kz: 'Соңғы кинолар'
    },
    allCinemasButton: {
        ru: 'Ко всем киноклубам',
        en: 'To all Cinema Clubs',
        kz: 'Барлық киноклубтарға'
    }
};
export const bookClubSinglePageLabels = {
    otherMeetings: {
        ru: 'Другие заседания',
        en: 'Other Meetings',
        kz: 'Басқа отырыстар'
    },
    allDiscussionsButton: {
        ru: 'Ко всем обсуждениям',
        en: 'To all discussions',
        kz: 'Барлық талқылауларға'
    }
};
export const poetryClubSinglePageLabels = {
    otherMeetings: {
        ru: 'Другие заседания',
        en: 'Other Meetings',
        kz: 'Басқа отырыстар'
    },
    allMeetingsButton: {
        ru: 'Ко всем заседаниям',
        en: 'To all meetings',
        kz: 'Барлық отырыстарға'
    },
    notFound: {
        ru: 'Заседание не найдено',
        en: 'Meeting not found',
        kz: 'Отырыс табылмады'
    }
};
export const eventSinglePageLabels = {
    latestEvents: {
        ru: 'Последние ивенты',
        en: 'Latest Events',
        kz: 'Соңғы оқиғалар'
    },
    allEventsButton: {
        ru: 'Ко всем ивентам',
        en: 'To All Events',
        kz: 'Барлық оқиғаларға'
    }
};

export const courseSinglePageLabels = {
    latestCourses: {
        ru: 'Последние курсы',
        en: 'Latest Courses',
        kz: 'Соңғы курстар'
    },
    allCoursesButton: {
        ru: 'Ко всем курсам',
        en: 'To All Courses',
        kz: 'Барлық курстарға'
    }
};

export const a11yLabels = {
  title: {
    ru: 'Меню специальных возможностей',
    en: 'Accessibility menu',
    kz: 'Арнайы мүмкіндіктер мәзірі'
  },
  profiles: {
    ru: 'Профили доступности',
    en: 'Accessibility profiles',
    kz: 'Қолжетімділік профильдері'
  },
  reset: {
    ru: 'Сбросить',
    en: 'Reset',
    kz: 'Қалпына келтіру'
  },
  on: { ru: 'Вкл', en: 'On', kz: 'Қосулы' },
  off: { ru: 'Выкл', en: 'Off', kz: 'Өшірулі' },

  tiles: {
    tts: { ru: 'Озвучка', en: 'Text to speech', kz: 'Дыбыстау' },
    mono: { ru: 'Ч/Б', en: 'B/W', kz: 'Қ/А' },
    textSize: { ru: 'Текст', en: 'Text size', kz: 'Мәтін' },
    lineHeight: { ru: 'Межстрочный', en: 'Line height', kz: 'Жол аралығы' },
    letterSpacing: { ru: 'Буквы', en: 'Letter spacing', kz: 'Әріп аралығы' },
    cursor: { ru: 'Курсор', en: 'Cursor', kz: 'Курсор' }
  },

  aria: {
    close: { ru: 'Закрыть', en: 'Close', kz: 'Жабу' },
    decreaseText: { ru: 'Уменьшить', en: 'Decrease', kz: 'Кішірейту' },
    increaseText: { ru: 'Увеличить', en: 'Increase', kz: 'Үлкейту' }
  }
};